import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  AddSurvey,
  AddSurveyQuestion,
  getCategoryList,
  getOutletTypes,
  getStatusActiveInActive,
  getSurvey_Category_Type,
  getSurveyConfiguration,
  getSurveyList,
  getSurveyQuestion,
  UpadteSurveyQuestion,
  UpdateSurvey,
} from "./SurveryRep";
import { toast } from "react-toastify";
import { showToast } from "../../../utils/toastUtils";

interface surveyInterface {
  page?: number;
  limit?: number;
  search?: string;
  audienceType?:string,
  status?:string,
  surveyCatid?:string,
}

export const useActive_InActiveStatus = ({ enable = false }) => {
  return useQuery({
    queryKey: ["GET_ACTIVE_INACTIVE_STATUS"],
    queryFn: getStatusActiveInActive,
    enabled: enable,
    retry: false,
  });
};

export const useGetSurveyList = ({
  enable = false,
  params,
}: {
  enable: boolean;
  params: surveyInterface;  
}) => {
  return useQuery({
    queryKey: ["GET_SURVEY_LIST", params],
    queryFn: () => getSurveyList(params),
    enabled: enable,
    retry: false,
  });
};

interface ReqBodyInterface {
  SurveyId?: number;
  SurveyName: string;
  StartDate: string;
  EndDate: string;
  SurveyCatid: number;
  Orgunitid: number;
  IsMultiple: string;
  OutletTypeId: number;
  Status: string | number;
  AudienceType: string;
  ShortCode: string;
  MediaId: number;
}

export const useGetOutletTypes = ({ enable = false }) => {
  return useQuery({
    queryKey: ["GET_OUTLET_TYPES"],
    queryFn: getOutletTypes,
    retry: false,
    enabled: enable,
  });
};

export const useGetCategoryType = ({ enable = false }) => {
  return useQuery({
    queryKey: ["GET_CATEGORY_TYPE"],
    queryFn: getSurvey_Category_Type,
    retry: false,
    enabled: enable,
  });
};

export const useSurveyConfiguration = ({ enable = false }) => {
  return useQuery({
    queryKey: ["GET_AUDIENCE_TYPE"],
    queryFn: getSurveyConfiguration,
    retry: false,
    enabled: enable,
  });
};

export const useAddSurvey = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (ReqBody: ReqBodyInterface) => AddSurvey(ReqBody),
    onSuccess: () => {
      showToast.success('Survey Added Successfully');
      queryClient.invalidateQueries({ queryKey: ["GET_SURVEY_LIST"] });
      queryClient.invalidateQueries({ queryKey: ["GET_SURVEY_QUESTION_LIST"] });
    },
    onError:()=>{
      showToast.error('Faild to Add Survey');
    }
  });
};

export const useUpdateSurvey = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (ReqBody: ReqBodyInterface) => UpdateSurvey(ReqBody),
    onSuccess: () => {
      showToast.success('Survey Updated Successfully');
      queryClient.invalidateQueries({ queryKey: ["GET_SURVEY_LIST"] });
      queryClient.invalidateQueries({ queryKey: ["GET_SURVEY_QUESTION_LIST"]});
    },
    onError:()=>{
      showToast.error('Failed to Update');
    }
  });
};

interface SurveyQuestionInterface {
  page: number;
  limit: number;
  search: string;
}

// export const useSurveyQuestionList = ({enable = false,params,SurveyID,}:{
//   enable: boolean;
//   params: SurveyQuestionInterface;
//   SurveyID: number;
// }) => {
//   return useQuery({
//     queryKey: ["GET_SURVEY_QUESTION_LIST", params],
//     queryFn: () => getSurveyQuestion(SurveyID, params),
//     enabled: enable,
//     retry: false,
//   });
// };

export const useSurveyQuestionList = ({
  retry = false,
  enable = false,
  params,
  SurveyID,
  refreshKey = 0, // NEW
}: {
  retry: boolean;
  enable: boolean;
  params: SurveyQuestionInterface;
  SurveyID: number;
  refreshKey?: number; // NEW
}) => {
  return useQuery({
    queryKey: ["GET_SURVEY_QUESTION_LIST", params, SurveyID, refreshKey], // 👈 ADD refreshKey
    queryFn: () => getSurveyQuestion(SurveyID, params),
    enabled: enable,
    retry: retry,
  });
};




interface AddSurveyQuestionInterface {
  Surveyquestype: string;
  Surveyquestionopt: string[];
  Question: string;
  Status: string;
  IsRequired: string;
  MediaId: number;

  SurveyQuestionID?:number
}

export const useAddSurveyQuestion = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ReqBody,surveyId, }: {ReqBody: AddSurveyQuestionInterface;surveyId: number | null;}) => AddSurveyQuestion(ReqBody, surveyId),
    onSuccess: () => {
    showToast.success('Survey Question Added Successfully');
    queryClient.invalidateQueries({ queryKey: ["GET_SURVEY_QUESTION_LIST"] });
    },
    onError:()=>{
      showToast.error('failed to add Survey Question')
    }
  });
};



export const useUpdateSurveyQuestion = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ( {ReqBody,SurveyQuestionID}:{ReqBody: AddSurveyQuestionInterface,SurveyQuestionID:number| null}) =>UpadteSurveyQuestion(ReqBody,SurveyQuestionID),
    onSuccess: () => {
      showToast.success("Updated Successfully");
      queryClient.invalidateQueries({ queryKey: ["GET_SURVEY_QUESTION_LIST"] });
    },
    onError:(error:any)=>{
    console.log('Failed to Update');
    showToast.error('Failed Update');
    }
  });
};

export const useGetCategoryList =({enable = false}:{enable:boolean})=>{
  return useQuery({
    queryKey:['GET_CATEGORY_LIST'],
    queryFn:getCategoryList,
    retry:false,
    enabled:enable
  })
} 